import { ChangeEvent } from 'react';

import Card from '../shared/Card';
import CardHeaderV2 from '../shared/Card/components/CardHeaderV2';

import OriginalLesseeForm from './OriginalLesseeForm';

type OriginalLesseeFormCardProps = {
  customHandleChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
};

const OriginalLesseeFormCard = ({ customHandleChange }: OriginalLesseeFormCardProps) => (
  <Card variant="rounded">
    <CardHeaderV2 title="Original Lessee" variant="square" />
    <OriginalLesseeForm customHandleChange={customHandleChange} />
  </Card>
);

export default OriginalLesseeFormCard;
